import { render } from "./csiInfo.vue?vue&type=template&id=56dc2611&scoped=true"
import script from "./csiInfo.vue?vue&type=script&lang=js"
export * from "./csiInfo.vue?vue&type=script&lang=js"

import "./csiInfo.vue?vue&type=style&index=0&id=56dc2611&lang=scss&scoped=true"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56dc2611"]])

export default __exports__